import { ToastContainer } from "react-toastify";
import Footer from "../components/Footer";
import Header from "../components/Header";
import 'react-toastify/dist/ReactToastify.css';

export default function DefaultLayout({ children }) {
    return <div className="h-full flex flex-col">
        <ToastContainer
            position="top-right"
            autoClose={2000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
            transition="Bounce"
        />
        <Header />
        { children }
        <Footer />
    </div>
}